import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef
} from '@angular/core';

import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth, isSameMinute,
  addHours
} from 'date-fns';

import { Subject } from 'rxjs';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

import {
  CalendarEvent,
  CalendarEventAction, CalendarMonthViewDay,
  CalendarEventTimesChangedEvent,
  CalendarView,
  CalendarEventTitleFormatter,
  CalendarMonthViewBeforeRenderEvent,
  CalendarWeekViewBeforeRenderEvent,
} from 'angular-calendar';
import { PortService } from 'src/app/core-services/port.service';
import { portcalvm } from 'src/app/models/portcalpostmodel';
import { CustomEventTitleFormatter } from './CalendarEventTitleFormatterOvrride';
import { Port } from 'src/app/models/Port';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { DefaultPort, DataParam } from 'src/app/Enum/Enum';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { drawDOM, exportPDF, DrawOptions, Group, Path, Text } from '@progress/kendo-drawing';
import { saveAs } from '@progress/kendo-file-saver';
import { Router } from '@angular/router';
import * as _ from "lodash";
import { ChangeDetectorRef } from '@angular/core';
import { Renderer2, ElementRef, AfterViewChecked } from '@angular/core';

interface EventGroupMeta {
  type: string;
}


const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA'
  }
};

@Component({
  selector: 'mwl-demo-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './portfullcalendar.component.html',
  styleUrls: ['./portfullcalendar.component.scss'],
  providers: [DatePipe,
    {
      provide: CalendarEventTitleFormatter,
      useClass: CustomEventTitleFormatter,
    }
  ],
  styles: [
    `
    .cell-totals {
      margin: 5px;
      text-align: left;
    }
    .badge {
      margin-right: 5px;
      margin-right: 5px;
      height: 25px;
      width: 100%;
    border: 1px solid #ccc;
    overflow: hidden;
    padding: 8px 5px;
    display: inline-table;
    }
    .custom-event {
      border: 1px solid silver;
    }
  `
  ]
})
export class PortfullcalendarComponent {

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  viewDate: Date = new Date();
  month: number = -1;
  transit = new portcalvm();
  voyagelist: any;
  vesselslist: any;
  vesselsListData: any;
  voyageListData: any;
  submitted: boolean = false;
  view: CalendarView;
  CalendarView = CalendarView;
  BremerPortId: number = 0;
  // viewDate: Date = new Date('10/01/2019');
  shippinglineslist: any;
  shippinglineslistData: any;
  portsData: Port[] = [];
  activeDayIsOpen = false;
  isShowFooter: boolean = false;
  modalData: {
    action: string;
    event: CalendarEvent;
  };
  refresh: Subject<any> = new Subject();
  events: CalendarEvent[] = [];
  eventsDayView = [];
  eventsWeekView = [];
  ismonth = true;
  isweek = false;
  isday = false;
  headerInjected = false;

  portCalform = this.fb.group({
    PortId: [""],
    vesselsId: [""],
    voyageId: [""],
    shippinglineId: [""]
  });

  vesselVoyageForm: FormGroup;

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
      
      setTimeout(() => this.refresh.next(null), 0);
    }
  }

private mutationObserver?: MutationObserver;

ngAfterViewInit(): void {
  const calendarEl = this.el.nativeElement.querySelector('mwl-calendar-month-view');

  // Observe DOM changes inside calendar to detect when open-day events are added
  this.mutationObserver = new MutationObserver(() => {
    const openDay = this.el.nativeElement.querySelector('.cal-open-day-events');
    if (openDay && !openDay.querySelector('.box-header')) {
      this.injectHeader(openDay);
    }
  });

  if (calendarEl) {
    this.mutationObserver.observe(calendarEl, { childList: true, subtree: true });
  }
}

private injectHeader(openDay: HTMLElement): void {
  // Create header DOM structure
  const header = this.renderer.createElement('div');
  this.renderer.addClass(header, 'wrapper1');
  this.renderer.addClass(header, 'box-header');

  const headers = [
    'Port', 'Schedule', 'ETA', 'ATA', 'ETD', 'ATD',
    'Ops Start', 'Ops End', 'Terminal', 'Berth', 'Action', ''
  ];

  headers.forEach(text => {
    const div = this.renderer.createElement('div');
    this.renderer.addClass(div, 'box');
    const textNode = this.renderer.createText(text);
    this.renderer.appendChild(div, textNode);
    this.renderer.appendChild(header, div);
  });

  // ✅ Insert at the top of the open-day events list
  openDay.insertBefore(header, openDay.firstChild);
}

ngOnDestroy(): void {
  if (this.mutationObserver) {
    this.mutationObserver.disconnect();
  }
}

  id: any;
  port: any;
  opsEnd: any;
  eTA: any;
  atA: any;
  etD: any;
  atD: any;
  opsStart: any;
  terminal: any;
  berth: any;


  UpdateVesselVoyage(value) {
    let request = this.vesselVoyageList.find(z => z.meta.voyagePortRoutesId = this.id);
    if (request) {
      request.meta.ata = this.removeTimeZone(this.atA);
      request.meta.atd = this.removeTimeZone(this.atD);
      request.meta.eTA = this.removeTimeZone(this.eTA);
      request.meta.eTD = this.removeTimeZone(this.etD);
      request.meta.opsEnd = this.removeTimeZone(this.opsEnd);
      request.meta.opsStart = this.removeTimeZone(this.opsStart);
      request.meta.terminal = this.terminal;
      request.meta.berth = this.berth;
    }

    this.portService.UpdateVesselVoyage(request).subscribe(z => {
      this.ngOnInit()
      this.modal.dismissAll();
    })
  }

  removeTimeZone(date) {
    if (date) {
      let momentDate = moment(date);
      return momentDate.format('YYYY-MM-DDTHH:mm:ss');
    }
    return null;
  }

  VesselClick(group) {
    console.log(group);
  }

  filePreview: string
  constructor(private modal: NgbModal, private portService: PortService, private fb: FormBuilder,
    public datepipe: DatePipe, private spinner: NgxSpinnerService,
    private toastr: ToastrService, private sanitizer: DomSanitizer,
    private router: Router,private cdr: ChangeDetectorRef,private renderer: Renderer2,
    private el: ElementRef
  ) {    
    this.view = CalendarView.Month;
  }

  groupedSimilarEvents: CalendarEvent[] = [];
  isAdmin = false;
  ngOnInit() {
    window.document.title = "ENL Solutions";
    const currentUser = localStorage.getItem('currentUser');
    const parsedCurrentUser = JSON.parse(currentUser);
    if (parsedCurrentUser && parsedCurrentUser.usersDetailsVM && parsedCurrentUser.usersDetailsVM.userRole == 1) {
      this.isAdmin = true;
    }
    const PortcalendarSearch = localStorage.getItem(DataParam.PortcalendarSearch);
    if (PortcalendarSearch) {
      const parsed = JSON.parse(PortcalendarSearch);
      console.log(parsed);
      this.portCalform.controls.PortId.setValue(parsed.PortId);
      this.portCalform.controls.vesselsId.setValue(parsed.vesselsId);
      this.portCalform.controls.shippinglineId.setValue(parsed.shippinglineId);
      this.onCalenderSearch(parsed);
    }
    this.getshippingline();
    this.getPortCalenderDropdowns();
  }

  NgOnDestroy() {
    console.log('On destroy')
    localStorage.removeItem(DataParam.PortcalendarSearch.toString());
  }

  getPortCalenderDataForMonth() {
    this.groupedSimilarEvents = [];
    const processedEvents = new Set();
    var transit = new portcalvm();
    transit.PortId = this.BremerPortId;
    transit.ShippingLineID = 0;
    transit.VesselsId = 0;
    transit.FromDate = '';
    transit.Todate = '';
    this.spinner.show();
    this.portService.GetPortCalenderDataForMonth(transit).subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.events = response.content;
        if (this.view == CalendarView.Month) {
          this.events.forEach(event => {
            event.title = this.getVesselDetailHeader(event.title);
            Object.defineProperty(event, 'actions', {
              value: [
                this.createVesselInfo(event),
                {
                  label: `<div class='wrapper1 wrapper2 wrapperUpdate'>                    
                  <div > <a class="link-primary">Update</a></div>        
                  </div>`,
                  a11yLabel: 'Update',
                  onClick: ({ event }: { event: CalendarEvent }): void => {
                    this.handleEditEvent('',event)
                  }
                }
              ]});
            event.start = new Date(event.start);
            event.end = new Date(event.end);
          });
        }
        this.spinner.hide();
      }
      this.spinner.hide();
    })
  }

  setView(view: CalendarView) {
    if (view == 'day') {
      this.ismonth = false;
      this.isday = true;
      this.isweek = false;
    }
    else if (view == 'week') {
      this.ismonth = false;
      this.isday = false;
      this.isweek = true;
    }
    else {
      this.ismonth = true;
      this.isday = false;
      this.isweek = false;
    }
    this.view = view;
    this.refreshView();
  }

  refreshView(): void {
    this.refresh.next(null);
  }


  beforeMonthViewRender({
    body
  }: {
    body: Array<CalendarMonthViewDay<EventGroupMeta>>;
  }): void {
    // month view has a different UX from the week and day view so we only really need to group by the type
    body.forEach(cell => {
      const groupcell = [];
      cell.events.forEach((event: CalendarEvent<EventGroupMeta>) => {
        const groups = {};
        //groups[event.meta.type] = groups[event.meta.type] || [];
        groupcell.push(event);
      });
      cell['eventGroups'] = Object.entries(groupcell);
    });
  }


  beforeViewRender($event) {
    const group: any[] = [];
    let i = 0;
    $event.period.events.forEach((event: any) => {
      const groups = {};

      if (i % 2 === 0) {
        group.push(event);
      }
      i++;
    });
  }

  getshippingline() {
    this.portService.GetShippingLines().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.shippinglineslist = response.content;
        const PortcalendarSearch = localStorage.getItem(DataParam.PortcalendarSearch);
        if (PortcalendarSearch) {
          const parsed = JSON.parse(PortcalendarSearch);
          this.portCalform.controls.shippinglineId.setValue(parsed.shippinglineId);
        }
      } else {
        this.shippinglineslist = null;
      }
    });
  }

  getVesselsbyShipsId(event) {
    this.portCalform.controls.vesselsId.setValue('');
    if (event != null && event.value != null) {
      var shipsId = event.value.shippingLineId > 0 ? event.value.shippingLineId : 0;
      if (shipsId > 0) {
        this.vesselslist = this.vesselsListData.filter(x => x.shippingLineid == shipsId);
        this.voyagelist = this.voyageListData;
        this.portCalform.controls.voyageId.setValue('');
      }
      else {
        this.vesselslist = this.vesselsListData;
        this.voyagelist = this.voyageListData;
      }
    }
    else {
      this.vesselslist = this.vesselsListData;
      this.voyagelist = this.voyageListData;
    }
  }

  getVoyagebyVesselsId(event) {
    this.portCalform.controls.voyageId.setValue('');
    if (event != null && event.value != null) {
      var vesselsId = event.value.id > 0 ? event.value.id : 0;
      if (vesselsId > 0) {
        this.voyagelist = this.voyageListData.filter(x => x.vesselsId == vesselsId);
      }
      else {
        this.voyagelist = this.voyageListData;
      }
    }
    else {
      this.voyagelist = this.voyageListData;
    }
  }


  searchPorts(event) {
    if (event != null && event.query != null && event.query != "") {
      if (event.query.length > 2) {
        var data = {
          PortName: event.query
        };
        this.portService.GetPortDataByName(data).subscribe((response: any) => {
          if (response != null && response.content != null) {
            this.portsData = response.content;
          } else {
            this.portsData = [];
          }
        });
      }
      else {
        this.portsData = [];
      }
    } else {
      //this.getPortData();

    }
  }

  getPortCalenderDropdowns() {
    this.portService.GetvoyageandvesselsList().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.voyagelist = response.content.voyages;
        this.vesselslist = response.content.vessels;
        this.vesselsListData = response.content.vessels;
        this.voyageListData = response.content.voyages;
        const PortcalendarSearch = localStorage.getItem(DataParam.PortcalendarSearch);
        if (PortcalendarSearch) {
          const parsed = JSON.parse(PortcalendarSearch);
          this.portCalform.controls.vesselsId.setValue(parsed.vesselsId);
        }
      } else {
        this.shippinglineslist = null;
      }
    });
  }

  vesselVoyageList: any[];
  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i><div>Heelo</div>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEditEvent('',event)
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i><div>Heelos</div>',
      a11yLabel: 'Schedule',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('',event)
      },
    }];

  onCalenderSearch(providedTransit?) {
    this.submitted = true;
    const data = providedTransit || this.portCalform.value;
    localStorage.setItem(DataParam.PortcalendarSearch, JSON.stringify(data));
    if (data.shippinglineId || data.vesselsId || data.PortId) {
      this.transit.ShippingLineID = data.shippinglineId != "" && data.shippinglineId != null ? data.shippinglineId.shippingLineId : 0;
      this.transit.VesselsId = data.vesselsId != "" && data.vesselsId != null ? data.vesselsId.id : 0;
      this.transit.VoyageId = data.voyageId != "" && data.voyageId != null ? data.voyageId.id : 0;
      this.transit.FromDate = this.datepipe.transform(this.viewDate, 'yyyy-MM-dd');
      this.transit.Todate = '';
      this.transit.PortId = data.PortId != "" && data.PortId != null ? data.PortId.id : 0;

      console.log(this.transit);

      this.spinner.show();
      this.portService.GetPortCalenderDataForMonth(this.transit).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.events = Object.assign([], response.content.portvmlist);
          this.eventsWeekView = this.CopyObject(response.content.portvmlist);
          this.eventsDayView = this.CopyObject(response.content.portvmlist);
          this.vesselVoyageList = this.CopyObject(response.content.portvmlist);
          if (this.view == CalendarView.Month) {
           
            this.events.forEach(event => {
              if(this.isAdmin){
                Object.defineProperty(event, 'actions', {
                  value: [
                    this.createVesselInfo(event),
                    {
                      label: `<div class='wrapper1 wrapper2'>                    
                      <div > <a class="link-primary">Update</a></div>        
                      </div>`,
                      a11yLabel: 'Update',
                      onClick: ({ event }: { event: CalendarEvent }): void => {
                        this.handleEditEvent('',event)
                      }
                    }
                  ]});
              }else{
                Object.defineProperty(event, 'actions', {
                  value: [
                    this.createVesselInfo(event)
                  ]});
              }
              // event.actions=this.actions,
              event.start = new Date(event.start);
              event.end = new Date(event.end);
            });
            this.eventsWeekView.forEach(event => {
              event.start = new Date(event.start);
              event.end = new Date(event.end);
            });
            this.eventsDayView.forEach(event => {
              event.start = new Date(event.start);
              event.end = new Date(event.end);
            });
          }

          this.spinner.hide();
          this.refreshView();
        }
        this.spinner.hide();
      }, (error) => {
        this.toastr.error(error.error.message);
      });
    }
    else {
      this.toastr.error("Please enter details", "Error!");
    }
  }

  getVesselDetailHeader(title) {
    if (this.isAdmin) {
      return `${title}</br>
<div class='wrapper1 box-header'>
<div class='box'>Port</div>
<div class='box'>Schedule</div>
<div class='box'>ETA</div>
<div class='box'>ATA</div>
<div class='box'>ETD</div>
<div class='box'>ATD</div>
<div class='box'>Ops Start</div>
<div class='box'>Ops End</div>
<div class='box'>Terminal</div>
<div class='box'>Berth</div>
<div class='box'>Action</div>
<div class='box'></div>
</div>`;
    } else {
      return `${title}</br>
<div class='wrapper1 box-header'>
<div class='box'>Port</div>
<div class='box'>Schedule</div>
<div class='box'>ETA</div>
<div class='box'>ATA</div>
<div class='box'>ETD</div>
<div class='box'>ATD</div>
<div class='box'>Ops Start</div>
<div class='box'>Ops End</div>
<div class='box'>Terminal</div>
<div class='box'>Berth</div>
<div class='box'">Action</div>
</div>`;
    }
  }

  CopyObject(arr) {
    const newArray = [];
    for (let index = 0; index < arr.length; index++) {
      newArray.push(Object.assign({}, arr[index]));
    }
    return newArray;
  }

  createVesselInfo(event) {
      if (this.isAdmin) {
       return {
          label:
          `<div class='wrapper1 wrapper2'>
        <div class='box'> ${event.meta.portname}</div>
        <div class='box'> ${this.ToFormat(event.meta.fullEta)}</div>
        <div class='box'> ${this.ToFormat(event.meta.estimatedArrivalDate)}</div>
        <div class='box'> ${this.ToFormat(event.meta.ata)}</div>
        <div class='box'> ${this.ToFormat(event.meta.fullEtd)}</div>
        <div class='box'> ${this.ToFormat(event.meta.atd)}</div>
        <div class='box'> ${this.ToFormat(event.meta.opsStart)}</div>
        <div class='box'> ${this.ToFormat(event.meta.opsEnd)}</div>
        <div class='box'> ${event.meta.terminal ? event.meta.terminal : ''}</div>
        <div class='box'> ${event.meta.berth ? event.meta.berth : ''}</div>
        <div class='box'> <a class="link-primary">Schedule</a></div>        
        </div>`,
          onClick: ({ event }: { event: CalendarEvent }): void => {
              this.handleEvent('Edited', event);
          }
        }
      } else {
        return {
          label: `<div class='wrapper1 wrapper2'>
        <div class='box'>${event.meta.portname}</div>
        <div class='box'> ${this.ToFormat(event.meta.fullEta)}</div>
        <div class='box'> ${this.ToFormat(event.meta.estimatedArrivalDate)}</div>
        <div class='box'> ${this.ToFormat(event.meta.ata)}</div>
        <div class='box'> ${this.ToFormat(event.meta.fullEtd)}</div>
        <div class='box'> ${this.ToFormat(event.meta.atd)}</div>
        <div class='box'> ${this.ToFormat(event.meta.opsStart)}</div>
        <div class='box'> ${this.ToFormat(event.meta.opsEnd)}</div>
        <div class='box'> ${event.meta.terminal ? event.meta.terminal : ''}</div>
        <div class='box'> ${event.meta.berth ? event.meta.berth : ''}</div>
        <div class='box'> <a class="link-primary">Schedule</a></div>
        </div>`,
        onClick: ({ event }: { event: CalendarEvent }): void => {
            this.handleEvent('Edited', event);
        }
        }
    }
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    const xx = this.modalData.event.meta.fullEta.split(' ');
    // path: "voyagedetail/:id/:fromPortId/:toPortId/:fromDate/:toDate/:shippingId",
    const url = '/' + 'voyagedetail' + '/' + this.modalData.event.id + '/' + this.modalData.event.meta.portId + '/null/' + this.dateConvert(xx[0]) + '/null/' + this.modalData.event.meta.shippingLineId + '/true';
    this.router.navigate([url]);

   
  }

  handleEditEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
        this.id = this.modalData.event.meta.voyagePortRoutesId;
    this.eTA = this.ConvertToDate(this.modalData.event.meta.estimatedArrivalDate);
    this.atA = this.ConvertToDate(this.modalData.event.meta.ata);
    this.etD = this.ConvertToDate(this.modalData.event.meta.fullEtd);
    this.atD = this.ConvertToDate(this.modalData.event.meta.atd);
    this.opsStart = this.ConvertToDate(this.modalData.event.meta.opsStart);
    this.opsEnd = this.ConvertToDate(this.modalData.event.meta.opsEnd);
    this.terminal = this.modalData.event.meta.terminal;
    this.berth = this.modalData.event.meta.berth;
    this.port = this.modalData.event.meta.portname;
    this.modal.open(this.modalContent, { windowClass: 'edit-vessel' });
  }


  dateConvert(str) {
    let parts;
    if(str.includes("/")){
       parts = str.split('/');
    }else{
       parts = str.split('-');
    }
   
    return parts[2] + '-' + (parts[1]) + '-' + parts[0];
  }

  ConvertToDate(dateStr) {
    if (dateStr) {
      let parsedDate = moment(dateStr, "DD/MM/YYYY HH:mm");
      if (parsedDate.isValid()) {
        return parsedDate.toDate();
      } else {
        return "";
      }
    } else
      return "";
  }

  ToFormat(dateStr) {
    if (dateStr) {
      let parsedDate = moment(dateStr, "DD/MM/YYYY HH:mm");
      if (parsedDate.isValid()) {
        return parsedDate.format("DD-MM-YYYY HH:mm");
      } else {
        return "";
      }
    } else {
      return "";
    }
  }


  closeOpenMonthViewDay() {
    let mon = this.viewDate.getMonth();
    this.activeDayIsOpen = false;
    if (this.month != mon) {
      this.month = this.viewDate.getMonth();
      this.getcalendereventdetails(this.viewDate);
    }
    else {
      this.month = this.viewDate.getMonth();
    }
  }

  getcalendereventdetails(currentdate) {
    var data = this.portCalform.value;
    if (data.PortId != "" || data.vesselsId != "" || data.voyageId != "" || data.shippinglineId != "") {
      this.transit.ShippingLineID = data.shippinglineId != "" && data.shippinglineId != null ? (data.shippinglineId as any)?.shippingLineId : 0;
      this.transit.VesselsId = data.vesselsId != "" && data.vesselsId != null ? (data.vesselsId as any)?.id : 0;
      this.transit.VoyageId = data.voyageId != "" && data.voyageId != null ? (data.voyageId as any)?.id : 0;
      this.transit.Todate = '';
      this.transit.PortId = data.PortId != "" && data.PortId != null ? (data.PortId as any)?.id : 0;
      this.transit.FromDate = this.datepipe.transform(this.viewDate, 'yyyy-MM-dd');
      this.spinner.show();
      this.portService.GetPortCalenderDataForMonth(this.transit).subscribe((response: any) => {
        if (response != null && response.content != null) {
          this.events = response.content.portvmlist;
          if (this.view == CalendarView.Month) {
            this.events.forEach(event => {
              event.title = this.getVesselDetailHeader(event.title);
              Object.defineProperty(event, 'actions', {
                value: [
                  this.createVesselInfo(event),
                  {
                    label: `<div class='wrapper1 wrapper2 wrapperUpdate'>                    
                    <div > <a class="link-primary">Update</a></div>        
                    </div>`,
                    a11yLabel: 'Update',
                    onClick: ({ event }: { event: CalendarEvent }): void => {
                      this.handleEditEvent('',event)
                    }
                  }
                ]});
              event.start = new Date(event.start);
              event.end = new Date(event.end);
            });
          }
          this.spinner.hide();
          console.log('dropdetails', response.content.responseconte);
          this.refreshView();
          if (this.transit.PortId == this.BremerPortId) {
            var data = {
              //PortName: DefaultPort.PortName
            };

            this.portService.GetPortDataByName(data).subscribe((response: any) => {
              if (response != null && response.content != null) {
                this.portsData = response.content;
                console.log('portdata', this.portsData);
                response.content.forEach(element => {
                  this.portCalform.controls.PortId.setValue(element);
                });

              }
            });
          }
        }
        this.spinner.hide();
      });
    }

    else {
      this.toastr.error("Please enter detail", "Error!");
    }
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  captureScreen1() {
    this.spinner.show();
    // var data = document.getElementById('contentToConvert');
    // html2canvas(data).then(canvas => {

    //   var HTML_Width = 800 //;canvas.width;
    //   var HTML_Height = canvas.height;
    //   var top_left_margin = 10;
    //   var PDF_Width = HTML_Width + (top_left_margin * 2);
    //   var PDF_Height = (PDF_Width * 1.5) + (top_left_margin * 2);
    //   var canvas_image_width = HTML_Width - 10;
    //   var canvas_image_height = HTML_Height;
    //   var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

    //   var imgData = canvas.toDataURL("image/png", 1.0);
    //   var pdf = new jspdf.jsPDF('p', 'pt', [PDF_Width, PDF_Height]);

    //   pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, canvas_image_width, canvas_image_height);

    //   for (var i = 1; i <= totalPDFPages; i++) {
    //     pdf.addPage([PDF_Width, PDF_Height]);
    //     pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height * i) + (top_left_margin * 4), canvas_image_width, canvas_image_height);
    //   }

    //   for (var i = 1; i <= totalPDFPages + 1; i++) {
    //     pdf.setPage(i);
    //     const base64ImgString = "iVBORw0KGgoAAAANSUhEUgAAAKwAAAA/CAYAAAB9wyM1AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjFDRkQwMUM5NkNDODExRUFBMUMyQTdGMENGOTE1NTA4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjFDRkQwMUNBNkNDODExRUFBMUMyQTdGMENGOTE1NTA4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MUNGRDAxQzc2Q0M4MTFFQUExQzJBN0YwQ0Y5MTU1MDgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MUNGRDAxQzg2Q0M4MTFFQUExQzJBN0YwQ0Y5MTU1MDgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7K1yzCAAAQzElEQVR42uxdCZgUxRV+PTO77OwBCyygInIoh4AQgXggEuMZQxJE1kQ0UfAARRSUeEZivBJJiAom0UiUoCgKiqISNUGUoAgqghKCrigogihyLLK7sMd03j/9OjZDz3RXzz3M+763M9tTVV1d9derV++9qtaC/SrHEtFE5hLmBsosKmRez/wL5o8s1+9gvoA5wNzkohyN2c/8JvPZcdYJ+X/HXM5cH+U+b0mdd8l1fJ/E3DxKGyNfgTzjCOaNXipWV63T+X18NGuIj6iGL+ien/Fa5nFSp8j2bSb1Qz2r5NpJzNOY+ca0mfkz5rXMq5jfZd6RKEBoDNh6qVgm0z3M18j3tsxfxlHWJAG8V1rD3NNFuiHM/5DvGHSdXJZ/I/NdngBbR9SjDSNluN8YNo2en7FaBlcsmsA8Vb7PFAFiRxi0i5nnMT8jZXsmjIjtlF1UHGf+25lbx5H/Gw95timk9S4XOadfE3kdH7kRCLWW77EkKID/Y+YZMnDvZT48HsA2ZAFIrVMv5EYozvIejCOv2/Zqiqhzosu371AtIe3tRs0KRfkei1oyjxdV4l75XxmwByJBDx1AeUoX+QS40NlH5gHrjh7NuSdi6VofikupSDW1FlXhUVms5gxg/UkoswfzRTmE1fBE3hjKSjH0c7EodMgVwJYkqdw/kWE6y3oKAbF7dLrocJ+xzGnMuv7pzbySuWu2AxYLrnlJKjsoyn/WS9c9NbyCaavRdf35v7qUV+HrBA0RqAjvMB8RLUFAsUAYga9m/oIMA3IqVAE0xqYk3uNy5inMn2S1dK3RadIgPwUq+J8v9USYtlTodpmtCgRssFMPZj6FuZViWZgf3pRyquMFLDr23zm4AHuEeVC2Stc6SNd2Go3rw//tSjlYQXtEiIHg5VokAC5j/gnzGOYTFcqrYH6FbCw5qipBIeUmncD8w2yWrjf19VFBRVrUgVgEJ8tjIm1hSqxSyNuf+Y/xArYgS/pRV2wc0MNZqbvWGtJ1QmKlazKsMnDLHimS1y3BHX9MPICty6K+hF71N4U87Zh/lXXSdbdON7B0DXiTrr2YRzPfwHwV88lyfUeyqsx8JfMlCnlmx6PDFmdRfzaTEarSOAiKeYDUfP/p011ZurZg6Xo1pOs3StL1O8x3RlGD1pFz4Is5i3mlh5i/Yn7ORdouZNjLH/YC2FuYi8iIwImlHgRklD5NqbYI7quXomHmMp+jkG86xR+CmBrpWqvTpBP8hu4Ky4C7+RJtMSfG70e4rMLmOB/heZnusUArdUg72Stg25MR9+iW/s48Kk19WiGfoxUBO4z5u8xvZzJg9+zl6a61RqO7a2HgugRrXwewqtA4WcUXxaEeIK622gVg0ZfnYwEXSHK79k9jn5qNsFP02UkKeR+RBUIGI5boxI4alSGMvNZ1rrkJrMEQ4VQR1LvHku3pSqcuWGb5/mvFhUSPNM4MrvRXatSpOzTNZppbbfIkiu72XCk6ZSZTP+izuRytFenfvlwxf7Q4Ay3dD9YEgPqJepZrKksfO2nIigX9QMCAoOrXMrxPz8llwEbqVk8yv6doEbnHDi9pX3CFVx8a9WultFjvZHMNYX0vy/fdZHikMpmGHWjxsCMV048Vs4qVvkn3Q5ihhFsgH0s044Izbu0GWnnE/60zvP+Kkw3YZul8ODKisayEmMunFct5JOL/tIdHY99WAT/dxQtD9OwylrftNKOlY29UsfP8VZJhyG9BRnjfjAwH7PPJBmw6XbkFUe4/WrGcyDiDmkzouULWrrfW8hz5dBPd8iILz2IGbSvRae2H1DNRioKZ8lPm1czdMxywc7yYtZbJtOh3AAt2496VxocLRZE5qNetZDhB3BKM1gfJ9z2Z0HMhfrLi5kS1ezS6bVGIlmxk5J3qo96dJaYAw8q3nyUAkXaDbYprkQXq3MdYg6gCFqNxfA7osr8hw3fudtcm4gxuYv5tpkjYsG4C0LIq0NRGo1c/CVGfWTpddTQD+BgfNT+YgbtTN+ILvgXuuWSE/yXC/v4QxRdqinkAIYk3M3/PRfr7yEPFX6PcIZi5nlBIf6cAdlUmPYQuTq6SCo1qWPZPfS1E86p0unaAj8b21sgP/bZaNwxYWhggxzPPZz4kzlvPtVgYvFIbl2oIdp2Et+ar6rCtcwiwqmYu0ESRUBlHUBGCrNcWs2TduIunjxeaqOusJpr2egg+BuO8nMKwXMMWFDhGYLKLjAdA3AdOq/ncxS07xFlluL+3WFQtJ2FR5wWwuUYXKKa/QyRzKFMfKKwmlBIVtdVo/TbW3xi43R5l4C7RjR21fJ1KeQ3iC7s6O4nEHUqGY6GjfLqxhJTGUc2TZS3kBn/VZDlaKnCAA/Z9UovmKpLOzeid/7pEGhaX8cgqY+DyMnP8ghDdt5ro0l4+GtpRo+4IJynSGsLAQeJ63XAd6GEYIY74Mv5eYDM4fZx+M/99OZxWfehi7TBVIf0o611UAbsrB0F7GalFcxEl1z1bnxzgEq37muj6l0N0YznRcazbHssapMZpChgO53fV6KiuPsP2s1e/LWzhCWgFDMpQBFx9/HtN2A0REpuJu9aAnff3zGcqPMKzFGGOUwVsxxwErBczV1LV0WRJ3GCJMZHXsVxdul6npVUyUTD4Jr+v0aijdDq8NYvPbToFfFTftkSr388/xoip2q7TZ6x99u+k0ZRBmjHE9Ji6KmzflyhWGwfS/ZT2v72yOQhK8lZKvhdLEx0HMZPTU2DmgsenVQYAFlPmasuCKLHSnIEVRK+X/b/oQk2jrbUNtHXG2yHDgWtY2I8ODx3Nxhjl17axZvnZFk43xb+fa/gwMqLCYO89g/lYjzU9iWwOxvOyReaaNHQigPvXJN9jDCU2XtQrwcyT0q30LIF3M4h/ROXaYrkEHfbiGFka6zQadGgJLReg4qzYsYKnjglYzJ/G/EE0IGQD9UnBPZ7yYObKFSqN0OOHOaQHMAda/j9apGrnBGAKOu7CWJIrG2h3iu5z4QFsMbHuW9jqIr01ai0RgfpY0MPj9ZLTVJsNlCozEiTsnAMUsE2K7Z3IPlkms6ijKnSgOw7s6PJ8E6SU4MWC8+JTt4uZPO1L28VqkKfkEuIQsM37ZtXVdzZ4u6x19LscaIE4BuStCdDL/FkmGAKK9dWifHcDVMQXYy/Z214qWZEFjWndDLjXZR6792ipEDxg8Zi5rJ3YNsvauJ2L9NZdyU5BUXhn13xZH6yMd1QhsOAKkQiZ5iP3iaSzHtSGCB/YCYfFAEpI0sQTbA0zF851Ot0DUGFDXGq5hsiom6S9M7WNrdtj7me+PobkRB9YTU8LmIdLemwXh7MHL9xYIe2wMlGVxYvl8FmcwYCNFr9Q6gDYRAVal3oArN1GRewvswsmydQ27kTGVvnIo6bwDOvrdlHNqV01+tdZPmPOC4VnETz7l8msrKm31FL20e4su08dZc/pj6ANium/StXoylOesobygM2TN0KgeEHqlZw8YPPkjRiom3bJqqckdaDNAzZPnqiIQbpik07nPRtCgKKxUVzPAzZPmapLMkYLS4lmrwzRiDlNtBsGROwXM89oTxJ4/QUH98y3fp68gQc7ako0WvW5TjPW6tSwl+iIUo3KjP1ihtvGLgg8SYBFIC5e2oCNd9vjkOAoA1HosOfVKOZtIWp9vYf7Im8gSl7YREsp9qvsUUa5PH9QPots/m+IIU9Q9+bSZapH5yO+tJvkVd1L11zqaOc40eS5AgrtirbAnqzOkqfWWlhBUKOdfOWVD0P0QJVOGxktFX6NDoX/q4Ucn9QorRQneO1UgqPIeH3iBuY3yDhEDPvUhyqWjQ1nCFnDdg/4jGFQxp53t+c3HSz3fc7Dcx0meaMd/Han/D4wRhlHykDdYfn8POJ/cKzg8u9LHpXTvycIINDueCMgzkGAp+hkhTKWyn3tXnlaJr896bKs6wRu2GGMMMCvJO+3rllsu2FVIIjDPLjHH1geouOfbKLBc0N09+IQfYEz0HHuFzYgxemeigx8qRBwYb8Wjll/T0Y5TjzBDkbs0fmni3LR0McxryHjDFJ4fhDwMETKwGhd6yT9Zf15kIfnMvNG84m3kt9jnc+PIOYHRSZAiuL4e+xPgrtxOX170Fwsz06R3KfcZb3hHh1JhqsUb51EyN0guYY3A1aSu9MX28l9h4mgmR8hpPCbm/iGS8l4IQZcrYiqguPjZ2RsDhwgg7p+H+AiIoGBu5eBu+RjnZZ8oNMtjKjhXTQa0V2jMzpxc5bL+V971VdRkYCtFLBiVP3Bch0ja5GMfifAThGw4vVB1tjSvzCPYH6c+UWyP2DXSuZUXe0BsGbeaFOpqZo0xCgDksR6wC8GHHzmOODuKZf1MMt340kcLsB8g/Z9jSjOsPqzCJKnBPxObYI+xOFpmJQfo33dy7pD21jp15YZy6S5IryGSj0X7ZeL79DMVMoYm7sZmDNXhGjmao36t9doTC8GbzeNSgtI+Xhon41EMPVXK70q+stYh/LQMBMFEHaB0LOlrI4yXWYTHWJRVZJB5msq7c5IeMciQNwcF1oms1ylSNNpHutk4qNvxPWzRMd2DmoRqVvMUjfA6FjBC7TRsxvppQ38Aw6s88UH2LmC+StkCsKpG+Z7mzaQs3/Z3NIbS++cKZ+nU55MaiuDGCrAF1HSzJLPM1yWOUD6EKrXlSJwSHESniyfq0TKn2mR1utI4UUnOBuhAFYvSN2WGi3ZrNMOvFusUBZmLeR825axOVIlwGvecfDBVFHyTUUf09EdLhZA5jS/JkYacytEhzQCJNOi0swp9/0Yab6OkPROZMaoni2ghe7bj9QCnaaJ2ni7zK7mDPugqAvKkVkAbpB12GlrdJr9URN1b6tRhyAvlJpr1L6Fg5JG9rsNIOYHi7XgNJmijhPFHXvVY71EuDFCtbAjM1A4mQcD+yPqE03H9WcIYBssU7lTX7kNYDcXQx8IWKEjY1fqYsW63U3GG3VOYT6VjBNcRota0E+EnBJhFVvI+utWfpKtvDCjBvPFeM42r1jTw2qp7PFSOdB0in3iy3/lM5YJpldE2mSQ2VnRTpYOpmDQqNAnlmk8GpnrirUeyh9lUfmKZYBoiu35oqxPymXhDDXmak/Tm268pyHISAryEA2yKgCpGywnR/bZjCa7Y4Hmi2nDR7GPF18hU87AiJWllcbJ5zOKK34VMo/56R3l94ERQEk3wez3uuiHlVHSTJTPxz2WjxN72oi1Zo8LtaiH9NElNurUL+V7t1Q3VCRge0sF74643ll0zjqLLhUNXCYgF1sUfZNg6uoiC6/1SXwuqAJPiPoxOeI32CZ7ioTfTJlDprSaI7OalcaLGQlrgxc8ln+PrB8uFNVjp0P6aplZp9tYCS6Tz2XpBuwwmXLQeFtE91lokUTnupB4MH7fLwsw5HtXTFkYmWOkvJEu6mbqbOg8q2dph0hxp7O2rpRZ4ToZZM/Ls82TKbFSsa1M439LhTylFiuAE70jdcZUDU/Vh2TsMIV0vJcMu6qKt6u9zbXzLN/bOOSHtWKExUrwpuBhnSy4/kP2L95LKkXGEjRYVIK+YqbCgy+QBddCl+UukIeskAVbF1kBw0U5wWUZAdF3N8n3WgtDOuCUkCUx8tfKAtEv5cBTBVM13Irw1lQptlVz6eQXBExuqERUo5dk4DrRW2KKKhN9tocAZ4qAx+1L7TDIl9P+rtmNsiCukfsscSgHoFwkg/VEWYjXywx8HiXwLFu39D8BBgB8HPRcPCcpmQAAAABJRU5ErkJggg==";
    //     pdf.addImage(base64ImgString, 30, (PDF_Height - 60), 60, 40);
    //     this.filePreview = 'data:image/png' + ';base64,' + base64ImgString;

    //     // Add website
    //     pdf.setFont("sans-serif", "futura-pt");
    //     pdf.setFontSize(15);
    //     pdf.text('Website URL : https://www.enl.solutions/', 300, (PDF_Height - 30), null, null);

    //   }


    //   var blob = pdf.output("blob"); // To open pdf in new tab
    //   window.open(URL.createObjectURL(blob));
    //   this.spinner.hide();

    // })

  }

  captureScreen() {
    this.isShowFooter = true;
    const elmnt = document.getElementById('multiPagePdf');
    console.log(elmnt);
    //var pageLength = $('#multiPagePdf').find('.page-break').length;
    const options: DrawOptions = {
      // forcePageBreak: '.page-break',
      landscape: true,
      paperSize: "A4",
      scale: 0.7,
      margin: { left: "1cm", top: "0.5cm", right: "1cm", bottom: "1.5cm" }

    };
    this.exportElement(elmnt, options, `export.pdf`);
  }

  /**
  * Generate PDF and download , upload and print the pdf...
  * @param element HTMLElement
  * @param options DrawOptions
  * @param pdfName pdfName
  */
  private exportElement(element: HTMLElement, options?: DrawOptions, pdfName = 'export.pdf') {
    this.spinner.show();
    // var websiteurl = 'Website URL : https://www.enl.solutions/';
    // const text = new Text(websiteurl, [5, 5], {
    //   font: `bold 15px Arial`
    // });

    drawDOM(element, options).then((group: Group) => {
      // group.append(text);
      // group.append(path,text)
      return exportPDF(group);
    }).then((dataUri) => {

      const blob: Blob = this.dataURItoBlob(dataUri);
      const file = new File([blob], pdfName, { type: 'application/pdf', lastModified: Date.now() });
      this.isShowFooter = false;
      const fileURL = window.open(URL.createObjectURL(file));
      // saveAs(dataUri, pdfName);


      this.spinner.hide();
    });
  }

  dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    const ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    const blob = new Blob([ab], { type: mimeString });
    return blob;

  }


}//






